module.exports = __webpack_public_path__ + "static/media/CL_Logo_White+Lemon_Horizontal.4fc217a1.png";